var React = require('react');

function ArrowLeftFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0605 21.2715C5.39648 21.2715 0.748047 16.6133 0.748047 10.9492C0.748047 5.29492 5.40625 0.636719 11.0605 0.636719C16.7246 0.636719 21.373 5.29492 21.373 10.9492C21.373 16.6133 16.7148 21.2715 11.0605 21.2715ZM13.3457 15.9883C13.7754 15.5586 13.7461 14.9043 13.3457 14.5137L9.54688 10.959L13.3457 7.41406C13.7559 7.02344 13.7559 6.33984 13.3262 5.93945C12.9355 5.57812 12.3105 5.57812 11.8906 5.96875L7.85742 9.73828C7.16406 10.3926 7.16406 11.5352 7.85742 12.1895L11.8906 15.9688C12.2715 16.3203 12.9941 16.3301 13.3457 15.9883Z","fill":"currentColor"}));
}

ArrowLeftFilled.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = ArrowLeftFilled;

ArrowLeftFilled.default = ArrowLeftFilled;
